import { Link } from "@tanstack/react-router";
import { FaTrashAlt } from "react-icons/fa";
import Card from "./card";
import ViewDetailButton from "../viewDetailButton";

const OrganizationCard = ({ organization, onDelete }: { organization: any; onDelete: (id: string) => void }) => {
  return (
    <Card className="flex flex-row">
      <div className="flex-grow">
        <div className="mb-4 flex items-start justify-between">
          <Link to={`/organizations/${organization.id}` as any} className="text-2xl text-blue-200">{organization.name}</Link>
          <button
            title="Delete Organization"
            className="mt-1 text-gray-400 hover:text-red-600"
            onClick={() => onDelete(organization.id)}
          >
            <FaTrashAlt />
          </button>
        </div>
        <p className="text-sm text-blue-400">ID: {organization.id}</p>
        <div className="mt-4 flex flex-row items-center gap-6">
          <p className="text-sm text-blue-400">
            Roles:{" "}
            {organization.roles?.map((role: any) => role.name).join(", ") || "None"}
          </p>
          <div className="grow" />
          <ViewDetailButton
            detailUrl={`/organizations/${organization.id}`}
            className="mt-0"
          />
        </div>
      </div>
    </Card>
  );
};

export default OrganizationCard;
